import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Status } from '../../cardview-grid/cardview-grid.types';

import { confidentiality, confidentialityOptions } from './detail-header.const';
import { DetailHeader } from './detail-header.types';

@Component({
  selector: 'app-detail-header',
  templateUrl: './detail-header.component.html',
  styleUrl: './detail-header.component.scss',
  standalone: false
})
export class DetailHeaderComponent {
  @Input() set data(detail: DetailHeader) {
    if (!detail) {
      return;
    }

    this.detailHeaderData = detail;
    this.confidentialityValue = detail?.confidential ? confidentiality.confidential : confidentiality.public;
    this.titleValue = detail?.title;
    this.descriptionValue = detail?.description;
  }
  @Input() editable: boolean;
  @Input() loading: boolean;
  @Input() infoVisible: boolean;

  @Input() loadingStatuses: boolean;
  @Input() availableStatuses: Status[];

  @Input() hasHistory: boolean;

  @Input() scrollContainerId: string;

  @Output() infoVisibleChange = new EventEmitter<boolean>();
  @Output() dataChange = new EventEmitter<DetailHeader>();

  @ContentChild('actionbarContent') actionbarContentTpl: TemplateRef<Element>;
  @ContentChild('extraOptionsContent') extraOptionsContentTpl: TemplateRef<Element>;

  public readonly confidentialityOptions = confidentialityOptions;
  public detailHeaderData: DetailHeader;
  public confidentialityDialogOpen = false;
  public confidentialityValue: confidentiality;
  public titleValue: string;
  public descriptionValue: string;

  get confidentiality(): { label: string; icon: string } {
    return confidentialityOptions[
      this.detailHeaderData?.confidential ? confidentiality.confidential : confidentiality.public
    ];
  }

  get selectableStatuses() {
    return this.availableStatuses.filter((status) => status.name !== this.detailHeaderData?.status?.name);
  }

  get hasDetailData() {
    return (
      this.detailHeaderData?.location ||
      this.detailHeaderData?.type ||
      this.detailHeaderData?.publicRef ||
      this.detailHeaderData?.description ||
      this.editable
    );
  }

  constructor(private translateService: TranslateService) {}

  openConfidentialityDialog() {
    this.confidentialityDialogOpen = true;
  }

  handleChangeConfidentiality({ value }: { value: confidentiality }) {
    this.confidentialityValue = value;
  }

  updateConfidentiality() {
    this.confidentialityDialogOpen = false;
    this.dataChange.emit({
      ...this.detailHeaderData,
      confidential: this.confidentialityValue === confidentiality.confidential
    });
  }

  resetConfidentiality() {
    this.confidentialityDialogOpen = false;
    this.confidentialityValue = this.detailHeaderData?.confidential
      ? confidentiality.confidential
      : confidentiality.public;
  }

  updateTitleValue() {
    this.dataChange.emit({
      ...this.detailHeaderData,
      title: this.titleValue
    });
  }

  updateDescriptionValue(value: string) {
    this.dataChange.emit({
      ...this.detailHeaderData,
      description: value
    });
  }
}
